document.addEventListener('DOMContentLoaded',function(){

  // Upsell Script Start
  var step_target = document.querySelectorAll('[JSMatchStepInit]'), upsell_item_add = document.querySelectorAll('[JSADDItemRoutineInit]'), upsell_add=document.querySelector('[JSEnabledUpsellAdd]');
  if(step_target.length > 0){
    step_target.forEach(function(step){
      step.addEventListener('click',function(e){
        e.preventDefault();
        var target_tab = this.getAttribute('href'), target_index = this.dataset.index;
        step_target.forEach(function(target){
          target.parentNode.classList.remove('active');
        })
        this.parentNode.classList.add('active');
        document.querySelectorAll('[JSItemTabLooper]').forEach(function(tab){
          tab.classList.remove('active')
        })
        document.querySelector(target_tab).classList.add('active');
      })
    })
  }

  var upsell_bundle_id = [], upsell_bundle_price =[], upsell_bundle_cmprice =[], items_json = [];
  let final_price=0, final_cmprice=0;

  if(upsell_item_add.length > 0){
    upsell_item_add.forEach(function(item){
      item.addEventListener('change',function(e){
        if(this.checked == true){
          var variant_value = this.value, variant_price = parseInt(this.dataset.price), variant_cmp= parseInt(this.dataset.comparePrice);
          upsell_bundle_id.push(variant_value);
          upsell_bundle_price.push(variant_price)
          upsell_bundle_cmprice.push(variant_cmp)
        }else{
          var upsell_value_index = upsell_bundle_id.indexOf(this.value), upsell_value_index_price = upsell_bundle_price.indexOf(parseInt(this.dataset.price));
          if (upsell_value_index > -1) { upsell_bundle_id.splice(upsell_value_index, 1); }
          if (upsell_value_index_price > -1) { upsell_bundle_price.splice(upsell_value_index_price, 1); }
          var upsell_value_index_cmp = upsell_bundle_cmprice.indexOf(parseInt(this.dataset.comparePrice));
          if (upsell_value_index_cmp > -1) { upsell_bundle_cmprice.splice(upsell_value_index_cmp, 1); }
          final_price=0; final_cmprice=0;
        }
        if(upsell_bundle_id.length > 0){
          document.querySelector('.ItemsSelectedCount').classList.remove('hide');
          upsell_add.removeAttribute('disable');
          document.querySelector('.ItemsSelectedCount .ItemsCount').innerHTML = upsell_bundle_id.length;
          document.querySelector('.ItemsIntialMsg').classList.add('hide');
        }else{ document.querySelector('.ItemsSelectedCount').classList.add('hide'); document.querySelector('.ItemsIntialMsg').classList.remove('hide'); upsell_add.setAttribute('disable','disable'); }
        if(upsell_bundle_price.length > 0){
          upsell_bundle_price.forEach(function(price){ final_price +=parseInt(price); })
          final_price = final_price / 100;
          document.querySelector('.SalePriceUpsell').innerHTML = '₹'+final_price
        }
        if(upsell_bundle_cmprice.length > 0){
          upsell_bundle_cmprice.forEach(function(cmprice){ final_cmprice += parseInt(cmprice); })
          final_cmprice = final_cmprice / 100;
          document.querySelector('.RegPriceUpsell s').innerHTML = '₹'+final_cmprice;
        }
        final_price = 0; final_cmprice=0;
      })
    })
  }

  if(upsell_add){
    upsell_add.addEventListener('click',function(e){
      e.preventDefault();
      if(upsell_bundle_id.length > 0){
        upsell_bundle_id.forEach(function(variant_id){
          items_json.push({ 'id': variant_id, 'quantity': 1 });
        })
        let formData = {'items':items_json, 'sections':''};
        fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData) })
        .then(response => { return response.json(); })
        .finally(() =>{
          document.querySelector('.site-header__cart-toggle').click();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }else if(upsell_item_add.length > 0){
        upsell_item_add.forEach(function(input){
          if(input.checked == true){
            items_json.push({ 'id': input.value, 'quantity': 1 });
          }
        })
        let formData = {'items':items_json, 'sections':''};
        fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(formData) })
        .then(response => { return response.json(); })
        .finally(() =>{
          document.querySelector('.site-header__cart-toggle').click();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }
    })
  }
  // Upsell Script End
  
  // Featured Section and Why US Script Start
    var play_button = document.querySelectorAll('[JSPLAYVideoInit]');
    if(play_button.length > 0){
      play_button.forEach(function(play){
        play.addEventListener('click',function(e){
          e.preventDefault();
          document.querySelectorAll('[JSParentTarget] video').forEach(function(video){
            video.closest('[JSParentTarget]').classList.remove('active');
            video.pause();
          })
          this.parentNode.classList.add('active')
          if(this.parentNode.querySelector('video.mobile-only') && this.parentNode.querySelector('video.desktop-only')){
            if(window.innerWidth <= 767){
              this.parentNode.querySelector('video.mobile-only').play();
              this.parentNode.querySelector('video.desktop-only').pause();
            }else{
              this.parentNode.querySelector('video.desktop-only').play();
              this.parentNode.querySelector('video.mobile-only').pause();
            }
          }else{
            this.parentNode.querySelector('video').play();
          }
        })
      })
    }
  // Featured Section and Why US Script End

  // FAQ Section Script Start
    var faq_target = document.querySelectorAll('[JSAccordianToggle]');
    if(faq_target.length > 0){
      faq_target.forEach(function(faq){
        faq.addEventListener('click',function(e){
          e.preventDefault();
          this.parentNode.classList.toggle('active');
          $(this).siblings('[JSContentToggle]').slideToggle();
        })
      })
    }

    $('.FAQTileMN.active .FAQ_answer').slideDown();
  
  // FAQ Section Script End

  var tab_target = document.querySelectorAll('.PDPTabItemInit a') ;
  if(tab_target.length > 0){
    tab_target.forEach(function(tab){
      tab.addEventListener('click',function(e){
        e.preventDefault();
        var target_tab = this.getAttribute('href'), target_index = this.dataset.index;
        tab_target.forEach(function(target){
          target.parentNode.classList.remove('active');
        })
        this.parentNode.classList.add('active');
        document.querySelectorAll('.PDPTabContent').forEach(function(tab){
          tab.classList.remove('active')
        })
        document.querySelector(target_tab).classList.add('active');
      })
    })
  }

  // Problems Mobile Slider Script Start
    var problems_slider = new Swiper('.BodyProblemsSlider.swiper',{
      spaceBetween: 0,
      centeredSlides: true,
      speed: 4000,
      mousewheel: {
        forceToAxis: true
      },
      autoplay: {
        delay: 1,
      },
      loop: true,
      allowTouchMove: false,
      disableOnInteraction: true,
      breakpoints:{
        1600:{
          slidesPerView: 'auto'
        },
        0:{
          slidesPerView: 'auto'
        }
      }
    })
  // Problems Mobile Slider Script End

  if(document.querySelectorAll('.BeforeAfterItemsWrpr .BeforeMediaInit').length > 0){
    var beforeSlide = new Swiper('.BeforeAfterItemsWrpr.swiper',{
      slidesPerView: 2.2,
      spaceBetween: 20,
      mousewheel: {
        forceToAxis: true
      },
      breakpoints:{
        767:{
          slidesPerView: 2.2
        },
        0:{
          slidesPerView: 1.2,
          spaceBetween: 20,
        }
      },
    })
  }

  if(document.querySelectorAll('.BenefitsPDWrpr .BeforeMediaInit').length > 0){
    var benefitsSlide = new Swiper('.BenefitsPDWrpr.swiper',{
      slidesPerView: 2.5,
      spaceBetween: 20,
      mousewheel: {
        forceToAxis: true
      },
      breakpoints:{
        767:{
          slidesPerView: 2.5
        },
        0:{
          slidesPerView: 1.3,
          spaceBetween: 10,
        }
      },
    })
  }

  var science_slider = new Swiper('.TabSciItemsWrpr.swiper',{
    slidesPerView: 3.2,
    spaceBetween: 20,
    mousewheel: {
      forceToAxis: true
    },
    breakpoints:{
      767:{
        slidesPerView: 3.2
      },
      0:{
        slidesPerView: 1.3,
        spaceBetween: 10,
      }
    },
  })

  var science_slider = new Swiper('.TabHTUItemsWrpr.swiper',{
    slidesPerView: 3.5,
    spaceBetween: 20,
    mousewheel: {
      forceToAxis: true
    },
    breakpoints:{
      767:{
        slidesPerView: 3.5
      },
      0:{
        slidesPerView: 1.3,
        spaceBetween: 10,
      }
    },
  })

  var ingredient_popup = document.querySelectorAll('[JSIngredientPop]');
  if(ingredient_popup.length > 0){
    ingredient_popup.forEach(function(popup){
      popup.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('.popup_bannerMN').classList.add('active');
      })
    })
  }

  var close_ing_pop = document.querySelector('.close_pop_ing');
  if(close_ing_pop){
    close_ing_pop.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('.popup_bannerMN').classList.remove('active');
    })
  }
})